import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PricingEngine from "@/pages/PricingEngine";
import Login from "@/pages/Login";
import { Toaster } from "sonner";
import { api, getToken, logout, setUnauthorizedHandler } from "@/lib/api";
import { Loader2 } from "lucide-react";

function App() {
  const [authState, setAuthState] = useState("checking"); // checking | out | in

  useEffect(() => {
    setUnauthorizedHandler(() => setAuthState("out"));

    if (!getToken()) {
      setAuthState("out");
      return;
    }
    api
      .get("/auth/me")
      .then(() => setAuthState("in"))
      .catch(() => setAuthState("out"));
  }, []);

  if (authState === "checking") {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 size={24} className="animate-spin text-[#1A2340]" />
      </div>
    );
  }

  if (authState === "out") {
    return (
      <div className="App grain">
        <Login onLoggedIn={() => setAuthState("in")} />
        <Toaster position="top-right" richColors closeButton />
      </div>
    );
  }

  return (
    <div className="App grain">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PricingEngine onLogout={() => { logout(); setAuthState("out"); }} />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
